module.exports = __webpack_public_path__ + "static/media/sraagraphic.b6561d0c.png";